/**
 * Telegram on Android uses an embedded Chromium WebView with stricter limits.
 * We keep bootstrap lightweight there to avoid startup crashes.
 */
export const isTelegramAndroidWebView = () => {
  if (typeof navigator === 'undefined') return false
  const ua = navigator.userAgent || ''
  return /\bAndroid\b/i.test(ua) && /\bTelegram(?:Bot)?\b/i.test(ua)
}
